/**
 * Created by su0012004  on 2020/8/20.
 * update by su0012004  on 2020/8/31.
 */


import Axios from 'axios';
import Qs from 'qs';
import md5 from 'js-md5'
import Storage from '@/components/libs/storage';
const  Config =  require('@/components/config/config');


Axios.defaults.timeout = 37500;// 请求的超时时间
Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
Axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
Axios.defaults.headers['wx-client-href' ] =  location.href
Axios.defaults.headers['X-Requested-With' ] = 'XMLHttpRequest' ;
Axios.defaults.withCredentials = true;
Axios.defaults.crossDomain = true;// 配置 CORS 跨域



// =======================api_token =======================
function create_api_token () {
  let data = {}
  data.clientId = Config.clientId// 客户端ID
  data.apiTime = '' + parseInt((new Date()).getTime() / 1000)
  data.apiToken = '' + md5(md5(Config.clientSecret) + md5(data.apiTime))
  return data
}
// =======================user_token =======================
function create_user_token () {
    const data = {}
    data.userToken = ''
    data.userId = 0
    data.adminid = 0;
    if(Storage.s_getItem('admin')){
        let admin  = Storage.s_getItem('admin');
        data.adminid = admin.id;
        data.userId = admin.user_id;
        data.userToken = admin.session3rd;
    }
    return data
}
// ==================headers =======================


function getheaders(){
  return {};
}


const config = {
   baseURL : '/service_api',  //  baseURL 将自动加在 url 前面，除非 url 是一个绝对 URL。
   // baseURL: Api.domain,
   'timeout': 30000, // 请求的超时时间
    //`withCredentails`选项表明了是否是跨域请求
    'withCredentials': true, // 允许携带cookie
    // 配置 CORS 跨域
    'crossDomain': true,
   // headers: {'Content-Type':'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest'},
   'headers': getheaders(),
    // transformRequest: [function (data) {
    //     // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
    //     data = Qs.stringify(data);
    //     return data;
    // }],
    //返回数据类型
    responseType: 'json',
}


if (process.env.NODE_ENV == 'development') {
    config.baseURL = '/service_api';
} else if (process.env.NODE_ENV == 'debug') {
    config.baseURL = '';
} else if (process.env.NODE_ENV == 'production') {
    config.baseURL =  '/service_api'; //'http://api.123dailu.com/';
}

const AxiosInst = Axios.create(config);

/**
*
* 请求拦截器
*/
AxiosInst.interceptors.request.use((res) => {
    res.headers.Authorization =  '';
   if(Storage.s_getItem('admin')){
        let admin  = Storage.s_getItem('admin');
        res.headers.Authorization = admin.session3rd  ;
    }
// 在实例已创建后修改默认值
    res.headers.clientid =  create_api_token().clientId ;
    res.headers.apitime = create_api_token().apiTime ;
    res.headers.apitoken = create_api_token().apiToken ;
    res.headers.usertoken =  create_user_token().userToken ;
    res.headers.userid = create_user_token().userId ;
    res.headers.time = parseInt((new Date()).getTime() / 1000);
    res.headers.adminid = create_user_token().adminid ;
    res.headers.siteid = Config.site_id ;
//=====
       if( res.method === 'delete' ){
       }
       if (res.method === 'post' ||  res.method === 'put'     ) {
        res.data = Qs.stringify(res.data)
       }
        return res;
},(error) => {
      return new Promise((resolve, reject) => {  reject(error) });
})

/**
*
* 响应拦截器
*/
AxiosInst.interceptors.response.use((response) => {
    if( response.status === 200){
            //对响应数据做些事
           if(response.data.status === 1) {
              // return response;
               //console.info('请求ok',response)
           }else{
                console.info('请求错误',response.data)
           }
    }else{
        alert('服务器错误'); return;
    }
    return response;
},(error) => {
    //请求错误时做些事
console.info('请求错误时做些事',error)
   return new Promise((resolve, reject) => {  reject(error) });
    // return new Promise.reject(err);
})

export default AxiosInst;



// WEBPACK FOOTER //
// ./src/components/libs/axiosInst.js